'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var React = require('react');
var styled = require('styled-components');
var Theme_Normalize_index = require('./Normalize/index.js');
var Theme_Fonts_index = require('../index-33f41a46.js');
var colors = require('../colors-8c38b626.js');
var Theme_common_index = require('./common/index.js');
var Theme_inputs_index = require('./inputs/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var baseGutter = 8;
var pixel = function (number) { return number + "px"; };
var gutters = {
    base: pixel(baseGutter),
    small: pixel(baseGutter / 2),
    big: pixel(baseGutter * 1.5),
};

var theme = tslib_es6.__assign(tslib_es6.__assign({ gutters: gutters,
    colors: colors.colors, fonts: Theme_Fonts_index.fontFamilies }, Theme_inputs_index['default']), Theme_common_index['default']);
var Theme = function (_a) {
    var children = _a.children, _b = _a.normalizeGlobalStyles, normalizeGlobalStyles = _b === void 0 ? false : _b, customTheme = _a.customTheme, fontFiles = _a.fontFiles;
    return (React__default['default'].createElement(styled.ThemeProvider, { theme: tslib_es6.__assign(tslib_es6.__assign({}, theme), customTheme) },
        normalizeGlobalStyles && React__default['default'].createElement(Theme_Normalize_index['default'], null),
        fontFiles && React__default['default'].createElement(Theme_Fonts_index.FontStyle, { fontFiles: fontFiles }),
        children));
};

exports.default = Theme;
exports.theme = theme;
//# sourceMappingURL=index.js.map
